export const constant = {
  // apiUrl: "http://127.0.0.1:8080/graphql/",
  apiUrl: "https://po.cs.ui.ac.id/api/graphql/"
};
